"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var react_1 = __importStar(require("react"));
var debounced_state_1 = require("../util/debounced_state");
exports.StyledSearchInput = (0, react_1.memo)(function StyledSearchInput(props) {
    var updateSearchQuery = props.updateSearchQuery, searchQuery = props.searchQuery, placeholder = props.placeholder, clearButtonLabel = props.clearButtonLabel, fullWidth = props.fullWidth, id = props.id, label = props.label, waitInterval = props.waitInterval, maxLength = props.maxLength;
    var _a = (0, debounced_state_1.useDebouncedState)(searchQuery, function (newValue) { return updateSearchQuery && updateSearchQuery(newValue !== null && newValue !== void 0 ? newValue : ''); }, waitInterval), value = _a[0], setValue = _a[1], flushValue = _a[2];
    var handleChange = function (event) {
        if (event && event.target) {
            var userInput = event.target.value || '';
            setValue(userInput);
        }
    };
    var handleOnClear = function () {
        setValue('');
        flushValue();
    };
    return (react_1.default.createElement(storm_ui_1.SearchInput, { id: (0, storm_ui_1.useUID)(id || 'quick-search-input'), placeholder: placeholder, value: value, onBlur: flushValue, onClear: handleOnClear, onChange: handleChange, fullWidth: fullWidth, clearButtonLabel: clearButtonLabel, label: label, maxLength: maxLength }));
});
